'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DecodeFilter = DecodeFilter;
function DecodeFilter($window) {
    'ngInject';

    return decode;

    /**
     * Decode an encoded URL string
     *
     * @param {String} input
     * @return {String} output
     */
    function decode(input) {
        return $window.decodeURI(input);
    }
}


/** WEBPACK FOOTER **
 ** ./src/decode.filter.js
 **/